/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPrescription } from 'app/shared/model/prescription.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ILensPrescription {
  id?: string;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  otc?: boolean | null;
  orderStatus?: keyof typeof OrderStatus | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  prescription?: IPrescription | null;
}

export const defaultValue: Readonly<ILensPrescription> = {
  active: false,
  exposed: false,
  otc: false,
};
